import type { IPlay } from '@dakedake/types'
import { playList } from '@/services'
import { useCallback, useState } from 'react'

export default function usePlay() {
  const [play, setPlay] = useState<IPlay[]>([])

  const getPlay = useCallback(async () => {
    const res = await playList()
    setPlay(res.data)
  }, [])

  return {
    play,
    getPlay
  }
}
